const barChartMessages =
  'Use this new dynamic visual to view the development pipeline as required. Change the axis, stacking options or filter by desired metrics. Get in touch with any questions or if you would like a demo from Airfinity analysts.'

export default barChartMessages
